export default "__VITE_ASSET__CZaXNPc$__"